module.exports = __webpack_public_path__ + "img/img_eshop05.84322daf.jpg";